// @ts-check

/**
 * @readonly
 * @typedef {user_prefs.Scope} UserPrefsScope
 */
const Scopes = {
  GLOBAL_ALL_USERS: /** @readonly @type {user_prefs.Scope.GLOBAL_ALL_USERS} */ (
    "GLOBAL_ALL_USERS"
  ),
  GLOBAL_USER: /** @readonly @type {user_prefs.Scope.GLOBAL_USER} */ (
    "GLOBAL_USER"
  ),
  WORKSPACE_ALL_USERS:
    /** @readonly @type {user_prefs.Scope.WORKSPACE_ALL_USERS} */ (
      "WORKSPACE_ALL_USERS"
    ),
  WORKSPACE_USER: /** @readonly @type {user_prefs.Scope.WORKSPACE_USER} */ (
    "WORKSPACE_USER"
  ),
};

/** @readonly @type {user_prefs.PreferencesByScope} */
const emptyPreferencesCollection = {
  [Scopes.GLOBAL_ALL_USERS]: {},
  [Scopes.GLOBAL_USER]: {},
  [Scopes.WORKSPACE_ALL_USERS]: {},
  [Scopes.WORKSPACE_USER]: {},
};

/** @readonly @type {user_prefs.Preferences} */
const defaultPreferences = {
  pinnedItems: [],
  teamCanvasViews: [],
  teamCanvasViewCollections: [],
  sideNav: {
    keepExpanded: true,
  },
  orgChartEditControls: {
    dismissed: false,
  },
  homeV2: {},
  homeTeamViews: [],
  headerSearch: {
    recentSearches: [],
    recentlyViewedPeople: [],
  },
};

export default {
  Scopes,
  emptyPreferencesCollection,
  defaultPreferences,
};
